import { GetServerSideProps } from 'next'
import LocationSlug from '@components/Location/LocationSlug'
import getAuctionsByLocationID from '@components/Location/server/getAuctionsByLocationID'
import { Auction, Location } from '@components/Location/location.types'
import bidapi from '../../../../../api/bidapi'
import normalizeQuery from '@utilities/functions/normalizeQuery'

type LocationProps = {
  auctions: Auction[]
  location: Location
}

const baseUrl = process.env.NEXT_PUBLIC_AUCTION_API as string

export const getServerSideProps: GetServerSideProps<LocationProps> = async (
  context: any
) => {
  try {
    const slug = normalizeQuery(context.params.slug)

    if (!slug) {
      return {
        redirect: {
          destination: '/location',
          permanent: false,
        },
      }
    }

    const [location]: [location: Location] = await bidapi({
      url: `${baseUrl}/location/getAllLocations?slug=${slug}`,
    })

    const auctions: any = await getAuctionsByLocationID(location.id)

    return { props: { auctions, location } }
  } catch (e) {
    return {
      redirect: {
        destination: '/location',
        permanent: false,
      },
    }
  }
}

export default LocationSlug
